import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import ApiHeader from '../../components/API/UIElements/Header';
import TitleBar from '../../components/API/UIElements/TitleBar';
import Footer from '../../components/Footer';
import Keys from '../../components/API/ApiKeys';
import './style.scoped.scss';
import { ROUTES, setElementHeights } from '../../assets/constants/strings';
import $ from 'jquery';
import { Redirect } from 'react-router-dom';
import { hasDeveloperApi, canUseApiKeys, isAuthenticated } from '../../services/entitlements';

const mapStateToProps = (state) => ({
  user: state.user.user,
});

const connector = connect(mapStateToProps, null);

const ApiKeys = ({ user }) => {
  useEffect(() => {
    $(window).on('resize', setElementHeights);
  }, []);

  useEffect(() => {
    setElementHeights();
  });

  if (!isAuthenticated(user)) {
    return <Redirect to={`${ROUTES.LOGIN}?portal=api`} />;
  }

  if (user && !hasDeveloperApi(user)) {
    return <Redirect to={ROUTES.APIACTIVATE} />;
  }

  // Only plans that grant keys reach this page (Trial and Enterprise both do). Any account
  // whose plan doesn't grant keys is sent to the Plans page to talk to us.
  if (user && !canUseApiKeys(user)) {
    return <Redirect to={ROUTES.APIPlans} />;
  }

  return (
    <div className='wf-doc-wrapper w-100' id='wf-doc-page'>
      <nav id='sticky-top-wrapper' className='navbar sticky-top p-0'>
        <div className='w-100 d-flex flex-column '>
          <ApiHeader hasNav />
          <TitleBar pageTitle='API Keys' compact />
        </div>
      </nav>

      <main role='main' className='wf-document px-0 mb-0' id='api-home'>
        <div id='main-content' className='col pl-4 mr-4'>
          <Keys />
        </div>
      </main>

      <Footer isDocument isCentered isAbsolute />
    </div>
  );
};

export default connector(ApiKeys);
